/**
 * Cream-matted frame with a torn-paper clip-path edge, a slight rotation,
 * and a drop-shadow on the *outer* wrapper (the clip-path would otherwise
 * cut the shadow off if it lived on the clipped element itself).
 */
import { useMemo } from "react";
import { getTornClipPath } from "./tornEdge";

const TornFrame = ({
  id,
  rotate = 0,
  pointsPerEdge = 18,
  jitter = 2.5,
  padding = "10px",
  background = "#efe7d3",
  onClick,
  className = "",
  style,
  children,
}) => {
  const clipPath = useMemo(
    () => getTornClipPath(id, { pointsPerEdge, jitter }),
    [id, pointsPerEdge, jitter]
  );

  const Wrapper = onClick ? "button" : "div";

  return (
    <Wrapper
      className={`torn-frame ${className}`}
      style={{ transform: `rotate(${rotate}deg)`, ...style }}
      onClick={onClick}
      type={onClick ? "button" : undefined}
      aria-label={onClick ? "View larger photo" : undefined}
    >
      <div className="torn-frame-inner" style={{ clipPath, padding, background }}>
        {children}
      </div>
    </Wrapper>
  );
};

export default TornFrame;
